import React, { ReactNode, useRef, useEffect, useState } from 'react';
import Tooltip, { TooltipProps } from 'antd/es/tooltip';
import cx from 'clsx';

import './index.css';

type AutoTooltipProps = {
  children: ReactNode;
  className?: string;
  auto?: boolean;
  help?: boolean;
  triggerTip?: boolean;
} & TooltipProps;

export const AutoTooltip = ({
  children,
  className,
  auto = true,
  help,
  title,
  triggerTip,
  ...rest
}: AutoTooltipProps) => {
  const innerRef = useRef<HTMLDivElement>(null);
  const [isOverflow, setOverflow] = useState<boolean | null>(null);

  useEffect(() => {
    setOverflow(innerRef.current!.scrollWidth > innerRef.current!.clientWidth);
  }, [title, triggerTip]);

  return (
    <Tooltip
      {...rest}
      title={auto ? (isOverflow ? title : null) : title}
      className={cx('db-autoTooltip', className)}
      mouseEnterDelay={0}>
      <div ref={innerRef} className={cx('db-autoTooltip-inner', help && 'db-autoTooltip-help')}>
        {children}
      </div>
    </Tooltip>
  );
};

export default AutoTooltip;
